import { heroLede } from '../content';
import heroBanner from '../assets/hero-banner-plain.jpg';

interface HeroProps {
  onHowTo: () => void;
}

export function Hero({ onHowTo }: HeroProps) {
  return (
    <header className="hero">
      {/* The banner photo carries the wordmark as a darkened full-bleed band.
          The <h1> stays live text (selectable, responsive) over it, so the
          image is decorative and needs no alt. */}
      <div
        className="hero__banner"
        style={{ backgroundImage: `url(${heroBanner})` }}
      >
        <div className="hero__banner-inner">
          <p className="hero__eyebrow">Delivering attacks on our communities</p>
          <h1 className="hero__title">
            Delete <span className="hero__strike">DoorDash</span>
          </h1>
        </div>
      </div>

      <div className="hero__inner">
        {heroLede.map((para) => (
          <p
            key={para.slice(0, 24)}
            className={
              para.includes('#DeleteDoorDash')
                ? 'hero__lede hero__lede--cta'
                : 'hero__lede'
            }
          >
            {para}
          </p>
        ))}

        <div className="hero__actions">
          <button type="button" className="btn btn--primary" onClick={onHowTo}>
            Delete your account
          </button>
        </div>
      </div>
    </header>
  );
}
